<script setup lang="ts">
const props = defineProps<{
  post?: PostItem | null;
}>();

const router = useRouter();
const route = useRoute();

const localePath = useLocalePath();
const { getPostTypeSlug } = usePostTypes();

const goBack = () => {
  const fullPath = route.fullPath;
  router.back();

  nextTick(() => {
    if (fullPath === route.fullPath) {
      const type = getPostTypeSlug(props.post?.type || PostType.Inspiration);

      const path = localePath({ name: "type", params: { type } });

      router.push(path);
    }
  });
};

const { sharePost } = usePostShare();

const share = () => {
  if (props.post) sharePost(props.post);
};

const { savePost, savePostAfterLogin } = usePostSave();
const { isLoggedIn, openAuthDialog } = useAuth();

const save = () => {
  if (!isLoggedIn.value) {
    savePostAfterLogin.value = props.post
      ? {
          post: props.post,
          image: props.post.cover,
        }
      : null;
    return openAuthDialog();
  }

  if (props.post) savePost(props.post, props.post.cover);
};

const { isDesktop } = useUserDevice();
</script>

<template>
  <PageHeader>
    <template #start>
      <PageHeaderActions>
        <PageHeaderButton padless class="mr-4" @click="goBack" title="Wróć">
          <Icon name="ns:arrow-left" class="w-6 h-6 lg:w-10 lg:h-10" />
        </PageHeaderButton>

        <template v-if="isDesktop">
          <PageHeaderButton @click="save">
            <Icon name="ns:heart" />
            <span>Dodaj do tablicy</span>
          </PageHeaderButton>

          <PageHeaderButton @click="share">
            <Icon name="ns:share-2" />
            <span>Udostępnij</span>
          </PageHeaderButton>
        </template>
      </PageHeaderActions>
    </template>

    <template #end>
      <PageTitle :default="post?.title" :hidden="post?.subtitle" />
    </template>
  </PageHeader>
</template>
